export type ErrorCode =
	| "unauthorized"
	| "forbidden"
	| "bad_request"
	| "not-found"
	| "validation"
	| "method_not_allowed"
	| "internal"
	| "invalid_credentials"
	| "email-not-verified"
	| "onboarding-already-completed"
	| "verification-invalid"
	| "verification-expired"
	| "invite-not-found"
	| "invite-already-accepted"
	| "invite-expired"
	| "user-already-exists"
	| "invite-already-exists"
	| "already-member"
	| "already-account-member"
	| "time-entry-already-registered"
	| "time-entry-not-open"
	| "time-clock-disabled"
	| "holiday-already-exists"
	| "holiday-not-deletable"
	| "holidays-import-failed"
	| "holidays-year-unsupported"
	| "waitlist-invite-not-found"
	| "waitlist-invite-expired"
	| "waitlist-invite-already-used"
	| "rdo_already_exists"
	| "rdo_not_editable"
	| "rdo_not_deletable"
	| "rdo_not_failed"
	| "rdo_not_finalized"
	| "rdo_revision_exists"
	| "rdo_pdf_unavailable"
	| "rdo_generation_unavailable"
	| "document_upload_missing"
	| "document_upload_invalid";

export interface APIErrorResponse {
	code: ErrorCode;
	message: string;
	details?: ErrorDetail[];
}

interface ErrorDetail {
	reason?: string;
	violations?: ErrorDetailFieldViolation[];
}

interface ErrorDetailFieldViolation {
	field: string;
	description: string;
}

export class APIError extends Error {
	public violations: { [key: string]: string };

	constructor(public apiError: APIErrorResponse) {
		super(apiError.message);

		this.violations = {};
		if (!apiError.details) return;

		for (const detail of apiError.details) {
			if (!detail.violations) continue;

			for (const violation of detail.violations) {
				this.violations[violation.field] = violation.description;
			}
		}
	}

	get code(): ErrorCode {
		return this.apiError.code;
	}

	get reason(): string {
		if (!this.apiError.details) return "";

		for (const detail of this.apiError.details) {
			if (!detail.reason) continue;

			return detail.reason;
		}

		return "";
	}
}
